import { DiscountType } from '@trnsact/trnsact-shared-types';
import { UpdateEquipmentVariables } from 'modules/equipment/api/equipment/types';

import { equipmentCalc } from './equipmentCalc';
import { QuoteEquipmentWithCharge } from '../types';

export function mapQuoteEquipmentToSync(
  equipmentForUpdate: QuoteEquipmentWithCharge
): Omit<
  UpdateEquipmentVariables['input'],
  'vendorOpportunityId' | 'dynamicsVendorOpportunityId' | 'attachments' | 'equipmentId'
> {
  const { price } = equipmentForUpdate;

  return {
    year: equipmentForUpdate.year,
    make: equipmentForUpdate.make,
    model: equipmentForUpdate.model,
    mileage: equipmentForUpdate.mileage,
    stockId: equipmentForUpdate.stockId,
    quantity: equipmentForUpdate.quantity,
    truckClass: equipmentForUpdate.class,
    newUsed: equipmentForUpdate.condition,
    serialNumberVin: equipmentForUpdate?.vin?.trim(),
    totalWholesaleCost: equipmentForUpdate.wholeSaleCost,
    additionalDescription: equipmentForUpdate.description,
    discountValue: price.discount ?? 0,
    wholesaleCost: price.wholesalePrice ?? 0,
    discountType: price.discountType ?? DiscountType.Flat,
    retailPrice: equipmentCalc.calcRetailPrice(equipmentForUpdate),
  };
}

export function checkingEquipmentUpgradeNeeds(
  equipmentForUpdate: QuoteEquipmentWithCharge,
  oldEquipment: Record<string, any>
) {
  const { price } = equipmentForUpdate;

  return [
    oldEquipment.retailPrice !== price.retailPrice,
    oldEquipment.discountValue !== price.discount,
    oldEquipment.wholesaleCost !== price.wholesalePrice,
    oldEquipment.discountType !== price.discountType,
  ].some(Boolean);
}
